<template>
<div v-if="messages && messages.length > 0">
  <!-- <v-row justify="center" v-if="messages"> -->
    <item v-for="(item, index) in messages" :key="index" :data="item" :previewData="previewData" />
    <!-- <v-dialog v-model="dialog" persistent max-width="290">
      <v-card :style="{ 'background-color': welcomeBGColor }">
        <v-card-text style="padding: 10px 0px 0px 0px;">
          <div style="width:100%;text-align: right;padding: 0 40px">
            <button 
            style="margin-right:-30px;margin-top:-10px;"
              @click="dialog = false"
            >
              <v-icon
                style="margin-left: 0px; color: white;font-size:30px;"
                :style="{ 'color': welcomeColor }"
                class="activity-button"
              >
                mdi-close
              </v-icon>
            </button>
          </div>
          <center style="margin-bottom: 20px;" v-if="icon && icon.length > 0 && icon !== '6'">
            <button 
              disabled="true"
              style="border-radius:50%; height:55px; width:55px; text-align:center; padding:5px 5px 10px 5px; opacity:0.7;"
              :style="{ 'background-color': welcomeColor}"
            >
              <v-icon
                style="margin-left: 0px; color: white;font-size:35px;"
                dark
                class="activity-button"
                :style="{ 'color': welcomeBGColor}"
              >
                {{icon}}
              </v-icon>
            </button>
          </center>
          <div style="padding: 10px" class="result-html">
            <vue-editor 
              v-model="messageLocale"
              :disabled="true"
              :editor-toolbar="aux"
              :style="{ 'color': `${welcomeColor} !important`, 'font-size': `500px !important` }"
            />
          </div>       
        </v-card-text>
      </v-card>
    </v-dialog> -->
  <!-- </v-row> -->
</div>
</template>

<script>
  import { mapState } from 'vuex'
  import { VueEditor } from "vue2-editor"
  import api from '@/services/api'
  import utils from '@/services/utils'
  import Item from './Item'
  export default {
    components: {
      VueEditor,
      Item
    },
    props: {
      previewData: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        messages: null,
        dialog: false,
        icon: null,
        message: null,
        messageLocale: null,
        welcomeBGColor: null,
        welcomeColor: null,
        aux: [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]],
      }
    },
    computed: {
      ...mapState('app',['locale','BGColor', 'FontContent', 'FontSizeContent', 'ColorContent']),
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },
      foodDrinkTextColor () {
        return this.$store.state.app.foodDrinkTextColor && this.$store.state.app.foodDrinkTextColor !== '' ? this.$store.state.app.foodDrinkTextColor : this.ColorContent
      },
    },
    watch: {
      locale (v) {
        if (this.message) this.messageLocale = utils.getTranslation (this.message, v)
      },
      previewData (v) {
        this.getPreviewData(v.id)
      }
    },
    mounted () {
      this.getModalData()
    },
    methods: {
      getPreviewData (v) {
        api.getAll(`enterprises/welcome-modal/${utils.getEnterpiseID()}/`, true, 1, 100000, '')
          .then(response => {
            const result = []
            for (const item of response.data) {
              if (item.ID === v) result.push(item)
            }
            this.messages = result
            if(this.messages.length > 0) this.dialog =true
          })
      },
      getModalData () {
        api.getAll('enterprises/welcome-modal', false, 1, 10000, '').then(response => {
          const result = []
          const welcomeModalHist = utils.getCustomToken('welcomeModal') ? utils.getCustomToken('welcomeModal').split(',') : [] 
          const newWelcomeModalHist = []
          for (const item of response.data.filter(x=>!x.Hide)) {
            const availability = JSON.parse(item.Availability)
            const aux = utils.isActive (availability)
            if (aux.date && aux.time && item.ID) {
              if (welcomeModalHist.indexOf(item.ID) === -1 || !item.Remember) result.push(item)
              if (item.Remember) newWelcomeModalHist.push(item.ID)
            }
            utils.setCustomToken('welcomeModal', newWelcomeModalHist.join(','))
            //utils.setCustomToken('welcomeModal', '')
            /*if (availability && availability.IsTemp) {
              const today = new Date(new Date().setHours(0,0,0,0))
              const startDate = new Date(new Date (availability.StartDate).setHours(0,0,0,0))
              const endDate = availability.EndDate ? new Date(new Date (availability.EndDate).setHours(0,0,0,0)) : null
              
              if(today >= startDate && (today <= endDate || availability.NoEndDate)) {
                if(item.ID)result.push(item)
              }
            } else {
              if(item.ID)result.push(item)
            }  */
            
          }
          this.messages = result
          // if(response.Message) {
          //   this.dialog = true
          //   this.icon = response.Icon && response.Icon.length > 0 ? response.Icon : null

          //   this.message = JSON.parse(response.Message)
          //   this.messageLocale = utils.getTranslation (this.message, this.locale)
          //   this.welcomeBGColor = response.BGColor
          //   this.welcomeColor = response.Color
          // }
        })
      }
    }
  }
</script>

<style scoped>
  .modal-allergens {
    background-color: rgba(241, 241, 241);
  }
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>
